import { Skeleton } from "@/components/ui/skeleton";
import TeamCard from "@/components/TeamCard";

const TeamSection = ({ team, loading }) => (
  <section className="py-16 md:py-20 bg-[color:hsl(var(--secondary))] border-t border-[color:var(--line)]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-xl mx-auto mb-10">
        <span className="text-sm font-medium text-[color:var(--brand-gold-2)] uppercase tracking-wide">Ekibimiz</span>
        <h2 className="font-[var(--font-serif)] text-2xl md:text-3xl font-semibold tracking-[-0.01em] text-[color:var(--brand-charcoal)] mt-2">
          Profesyonel Ekibimiz
        </h2>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-2xl mx-auto">
          {[1, 2].map((i) => (
            <Skeleton key={i} className="h-[180px] rounded-[14px]" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-2xl mx-auto" data-testid="home-team-grid">
          {team.map((m) => (
            <TeamCard key={m.id} member={m} />
          ))}
        </div>
      )}
    </div>
  </section>
);

export default TeamSection;
